<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            inline-prompt
            active-text="正常"
            active-color="#1e90ff"
            inactive-text="停用"
            inactive-color="#f00"
            :active-value="1"
            :inactive-value="0"
            style="--el-switch-off-color: #f00"
          />
        </el-form-item>
        <el-form-item
          label="账户名称"
          prop="name"
          :rules="[{ required: true, message: '请填写名称', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="账号"
          prop="account"
          :rules="[{ required: true, message: '请填写账号', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.account" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="开户行"
          prop="opening_bank"
          :rules="[
            { required: true, message: '请填写开户行', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.opening_bank"></el-input>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建时间">
            <el-input v-model="state.model.create_time" disabled></el-input>
          </el-form-item>
          <el-form-item label="修改时间">
            <el-input v-model="state.model.update_time" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  bankaccount_add,
  bankaccount_edit,
  bankaccount_detail,
} from "@/http/bankaccount";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { status: 1 },
    });
    onMounted(() => {
      if (props.id) {
        bankaccount_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            if (state.model.pid == 0) delete state.model.pid;
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            bankaccount_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            bankaccount_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
